import type { TasProgramInstanceState } from 'tio-common/types/tuition-assistance';
import type { ChipSignature } from 'tio-reimagined/components/chip';

const tasProgramInstanceStateBadgeMap: Record<
  string,
  { intent: ChipSignature['Args']['intent']; label: string }
> = {
  'TAS.ProgramInstanceState.CREATED': { intent: 'success', label: 'In Progress' },
  'TAS.ProgramInstanceState.DRAFT': { intent: 'success', label: 'In Progress' },
  'TAS.ProgramInstanceState.PENDING_PROGRAM_APPROVAL': { intent: 'primary', label: 'Pending' },
  'TAS.ProgramInstanceState.PROGRAM_APPROVED': { intent: 'success', label: 'In Progress' },
  'TAS.ProgramInstanceState.PROGRAM_NOT_APPROVED': { intent: 'danger', label: 'Rejected' },
  'TAS.ProgramInstanceState.PROGRAM_REJECTED': { intent: 'danger', label: 'Rejected' },
  'TAS.ProgramInstanceState.PRIMED': { intent: 'success', label: 'In Progress' },
  'TAS.ProgramInstanceState.PENDING_COMPLETION_APPROVAL': {
    intent: 'primary',
    label: 'Pending',
  },
  'TAS.ProgramInstanceState.COMPLETION_APPROVED': { intent: 'success', label: 'In Progress' },
  'TAS.ProgramInstanceState.COMPLETION_NOT_APPROVED': { intent: 'danger', label: 'Rejected' },
  'TAS.ProgramInstanceState.COMPLETION_REJECTED': { intent: 'danger', label: 'Rejected' },
  'TAS.ProgramInstanceState.PENDING_WITHDRAWAL_APPROVAL': {
    intent: 'primary',
    label: 'Pending',
  },
  'TAS.ProgramInstanceState.WITHDRAWAL_APPROVED': { intent: 'warning', label: 'Withdrawn' },
  'TAS.ProgramInstanceState.WITHDRAWAL_NOT_APPROVED': {
    intent: 'danger',
    label: 'Withdrawal Not Approved',
  },
  'TAS.ProgramInstanceState.WITHDRAWAL_REJECTED': {
    intent: 'danger',
    label: 'Withdrawal Rejected',
  },
  'TAS.ProgramInstanceState.COMPLETED': { intent: 'success', label: 'Completed' },
  'TAS.ProgramInstanceState.WITHDRAWN': { intent: 'danger', label: 'Withdrawn' },
  'TAS.ProgramInstanceState.ABANDONED': { intent: 'danger', label: 'Abandoned' },
};

export const instanceBadgeState = (state: TasProgramInstanceState, approvalRequired: boolean) => {
  if (!approvalRequired && state === 'TAS.ProgramInstanceState.PENDING_PROGRAM_APPROVAL') {
    return tasProgramInstanceStateBadgeMap['TAS.ProgramInstanceState.PROGRAM_APPROVED'];
  }
  return tasProgramInstanceStateBadgeMap[state];
};
